/**
 * Shared helper for triggering a browser download from an in-memory Blob
 * (e.g. one fetched from a server-side PDF export endpoint via
 * apiClient.downloadBlob). Mirrors vin-pulse-os-web/src/utils/downloadBlob.ts.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
